// extracted by mini-css-extract-plugin
export default {"Button":"AMKvgKOc","ButtonText":"upmw4lhW","ButtonWhiteText":"NoaIirr_"};